interface Props {
  title: string;
}

const Error: React.FC<Props> = ({ title }) => {
  return (
    <div className="p-3 m-3 rounded-xl bg-pkc-red-calendar bg-opacity-30">
      در حال حاضر دریافت گزارش «{title}» امکان پذیر نیست. لطفا بعدا تلاش فرمایید، در صورت عدم نمایش با پشتیبانی پزشک خوب
      تماس بگیرید.
    </div>
  );
};

export default Error;
